import {
  GTM_CLICK_MAP_PIN_LISTING,
  GTM_CLICK_SEARCH_PAGE_SATELLITE_VIEW,
  GTM_CLICK_SEARCH_PAGE_STREET_VIEW,
  GTM_SEARCH_PAGE_VIEW,
  GTM_SEARCH_PAGE_MLML_VIEW,
  GTM_SIMPLE_CHAT_VIEW,
  GTM_SIMPLE_CHAT_CLOSE_LIST,
  GTM_SIMPLE_CHAT_CHOOSE_BATHROOMS,
  GTM_SIMPLE_CHAT_CHOOSE_BEDROOMS,
  GTM_SIMPLE_CHAT_CHOOSE_BUDGET,
  GTM_SIMPLE_CHAT_CLEAR_SEARCH,
  GTM_SIMPLE_CHAT_CLICK_ADD,
  GTM_SIMPLE_CHAT_CLOSE_CHAT,
  GTM_SIMPLE_CHAT_REMOVE_BATHROOMS,
  GTM_SIMPLE_CHAT_REMOVE_BEDROOMS,
  GTM_SIMPLE_CHAT_REMOVE_BUDGET,
  GTM_SIMPLE_CHAT_SAVE_PROPERTY_TYPE,
  GTM_SIMPLE_CHAT_SWITCH_TO_REGULAR_CHAT,
  GTM_CLICK_MAP_PAGE_SIDEBAR_CARD,
  GTM_CLICK_MAP_PAGE_PIN,
  GTM_CLICK_MAP_PAGE_LISTING_POPOVER,
  GTM_MAP_PAGE_FAVOURITE_PROPERTY,
} from 'constants/events';
import { trackEvent } from 'utils/google-tag-manager';

export const TrackPageView = () => trackEvent(GTM_SEARCH_PAGE_VIEW);
export const TrackMLMLPageView = (showsMLML: boolean) => {
  if (showsMLML) {
    trackEvent(GTM_SEARCH_PAGE_MLML_VIEW);
  }
};
export const TrackMoreButtonClick = () => trackEvent('UiSrchQfMoreButClk');
export const TrackSaveSearchButtonClick = () => trackEvent('UiSrchQfSaveButClk');
export const TrackMapPinListingClicked = () => {
  trackEvent(GTM_CLICK_MAP_PIN_LISTING);
  trackEvent(GTM_CLICK_MAP_PAGE_PIN);
  trackEvent('UiSrcMapCardClusterClk');
};
export const TrackMapPinListingNoModalClicked = () => {
  trackEvent('Xp_UiAddresspView');
  trackEvent(GTM_CLICK_MAP_PIN_LISTING);
};
export const TrackSatelliteViewClicked = () => trackEvent(GTM_CLICK_SEARCH_PAGE_SATELLITE_VIEW);
export const TrackStreetViewClicked = () => trackEvent(GTM_CLICK_SEARCH_PAGE_STREET_VIEW);
export const TrackSimpleChatView = () => trackEvent(GTM_SIMPLE_CHAT_VIEW);
export const TrackSimpleChatSavePropertyType = () => trackEvent(GTM_SIMPLE_CHAT_SAVE_PROPERTY_TYPE);
export const TrackSimpleChatChooseBedrooms = () => trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BEDROOMS);
export const TrackSimpleChatChooseBathrooms = () => trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BATHROOMS);
export const TrackSimpleChatChooseBudget = () => trackEvent(GTM_SIMPLE_CHAT_CHOOSE_BUDGET);
export const TrackSimpleChatClearSearch = () => trackEvent(GTM_SIMPLE_CHAT_CLEAR_SEARCH);
export const TrackSimpleChatClickAdd = () => trackEvent(GTM_SIMPLE_CHAT_CLICK_ADD);
export const TrackSimpleChatRemoveBedrooms = () => trackEvent(GTM_SIMPLE_CHAT_REMOVE_BEDROOMS);
export const TrackSimpleChatRemoveBathrooms = () => trackEvent(GTM_SIMPLE_CHAT_REMOVE_BATHROOMS);
export const TrackSimpleChatRemoveBudget = () => trackEvent(GTM_SIMPLE_CHAT_REMOVE_BUDGET);
export const TrackSimpleChatSwitchToRegularChat = () => trackEvent(GTM_SIMPLE_CHAT_SWITCH_TO_REGULAR_CHAT);
export const TrackSimpleChatCloseChat = () => trackEvent(GTM_SIMPLE_CHAT_CLOSE_CHAT);
export const TrackSimpleChatCloseList = () => trackEvent(GTM_SIMPLE_CHAT_CLOSE_LIST);

export const TrackMapListingCardClicked = () => trackEvent(GTM_CLICK_MAP_PAGE_SIDEBAR_CARD);
export const TrackMapListingPopoverCardClicked = () => trackEvent(GTM_CLICK_MAP_PAGE_LISTING_POPOVER);
export const TrackMapListingFavouriteClicked = () => trackEvent(GTM_MAP_PAGE_FAVOURITE_PROPERTY);